export const numFiveStarReviewsText = '250k';
export const numFiveStarReviewsCount = '250,000';
export const numMembersText = '12 million';
export const numMembersCount = '4,000,000';
